export const SEND_SMS_APP_LINK = 'SEND_SMS_APP_LINK';
export const SEND_SMS_APP_LINK_DONE = 'SEND_SMS_APP_LINK_DONE';
export const SEND_SMS_APP_LINK_ERROR = 'SEND_SMS_APP_LINK_ERROR';
export const RESET_SEND_SMS_APP_LINK = 'RESET_SEND_SMS_APP_LINK';
//# sourceMappingURL=actionTypes.js.map